import {
  StyledSelect
} from "./chunk-RWT4HETL.mjs";
import {
  Tick_default
} from "./chunk-Y6SSNC6R.mjs";

// src/components/select/select-item.tsx
import React, { forwardRef } from "react";
var SelectItem = forwardRef(
  function SelectItem2({ item, children, ...rest }, ref) {
    return /* @__PURE__ */ React.createElement(StyledSelect.Item, { ref, key: item.value, item, ...rest }, children, /* @__PURE__ */ React.createElement(StyledSelect.ItemIndicator, null, /* @__PURE__ */ React.createElement(Tick_default, null)));
  }
);

export {
  SelectItem
};
